@if (asset(); as asset) {
  <div class="asset-tooltip">
    <div class="asset-tooltip__header">{{ asset.name }}</div>
    @if (!ready()) {
      <div class="asset-tooltip__body asset-tooltip__body--loading">
        <sim-spinner [diameter]="24" [strokeWidth]="3" />
      </div>
    } @else {
      <div class="asset-tooltip__body">
        @if (isPreview) {
          <p class="asset-tooltip__preview-note" i18n="@@ASSET_TOOLTIP_AI_PREVIEW_NOTE">
            Example generated by AI. It will be added to the space only after you confirm the detected assets.
          </p>
        }
        @if (asset.textNote) {
          <p class="asset-tooltip__description">{{ asset.textNote }}</p>
        }
        @if (hasAttachments()) {
          <div class="asset-tooltip__attachments">
            @if (imagesCount() > 0) {
              <sim-attachment-tile
                type="image"
                [src]="imageUrl()"
                [alt]="asset.name"
                [count]="imagesCount()"
                [class.asset-tooltip__tile--clickable]="canShowMore"
                (click)="showMore('images')"
              />
            }
            @if (videosCount() > 0) {
              <sim-attachment-tile
                type="video"
                [count]="videosCount()"
                [class.asset-tooltip__tile--clickable]="canShowMore"
                (click)="showMore('videos')"
              />
            }
            @if (documentsCount() > 0) {
              <sim-attachment-tile
                type="document"
                [count]="documentsCount()"
                [class.asset-tooltip__tile--clickable]="canShowMore"
                (click)="showMore('documents')"
              />
            }
          </div>
        }
        @if (canShowMore) {
          <div class="asset-tooltip__footer">
            <button
              type="button"
              class="asset-tooltip__show-more"
              (click)="showMore()"
              i18n="@@ASSET_TOOLTIP_SHOW_MORE"
            >
              Show more
            </button>
          </div>
        }
      </div>
    }
  </div>
}
